import { ofType } from 'redux-observable';
import { filter, mergeMap } from 'rxjs/operators';

import { analyticsIterablePushNotificationOpen as analyticsIterablePushNotificationOpenAction } from '@perpay-web/fintech/actions/analytics/tracking';
import { routeToLocation } from '@perpay-web/fintech/actions/router';
import { authentication } from '@perpay-web/fintech/settings/singletons';
import { nativeClientPushNotificationReceived } from '@perpay-web/native-client/actions/push';
import { handleError } from '@perpay-web/observable/operators/handleError';
import { parseAbsoluteURL } from '@perpay-web/utils/urlUtils';

function getReactNativePushObservable(action$) {
    return action$.pipe(
        ofType(nativeClientPushNotificationReceived().type),
        mergeMap((action) => {
            const { payload } = action;

            return [payload];
        }),
    );
}

export const analyticsIterablePushNotificationOpen = (action$) => {
    const push$ = getReactNativePushObservable(action$);

    return push$.pipe(
        // We only care about Iterable-initiated pushes here
        filter((pushData) => Boolean(pushData.itbl)),
        // Combine the push data with the user's email address from the latest access token
        mergeMap((pushData) => {
            const { campaignId, messageId, templateId } = JSON.parse(
                pushData.itbl,
            );

            return authentication
                .getRefreshedEmail()
                .then((email) =>
                    analyticsIterablePushNotificationOpenAction(
                        email,
                        campaignId,
                        messageId,
                        templateId,
                    ),
                );
        }),
        handleError(() => []),
    );
};

export const navigateOnNativeUrlPush = (action$) => {
    const push$ = getReactNativePushObservable(action$);

    return push$.pipe(
        // We only care about Iterable-initiated pushes here
        filter((pushData) => Boolean(pushData.uri)),
        // Combine the push data with the user's email address from the latest access token
        mergeMap((pushData) => {
            const { uri } = pushData;
            return [routeToLocation(parseAbsoluteURL(uri))];
        }),
        handleError(() => []),
    );
};
